import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TabBarItem } from '@frontend/sports/web/tab-bar-utils';
import { DsSegmentedControlModule } from '@frontend/ui/segmented-control';

@Component({
    selector: 'ms-my-bets-sub-navigation',
    templateUrl: './my-bets-sub-navigation.component.html',
    imports: [DsSegmentedControlModule],
})
export class MyBetsSubNavigationComponent {
    @Input() tabs: TabBarItem[] = [];
    @Output() tabClick = new EventEmitter<TabBarItem>();

    getTabTitle(tab: TabBarItem): any {
        return tab.count ? `${tab.title} (${tab.count})` : tab.title;
    }

    getActiveOption(): number {
        const tabLength = this.tabs.findIndex((tab) => tab.active === true);

        if (tabLength === -1) {
            return this.tabs.length - 1;
        }

        return this.tabs.findIndex((tab) => tab.active === true);
    }

    onSelectionChange(active: string): void {
        const activeIndex = parseInt(active);

        const selectedTabs = this.tabs[activeIndex];
        this.tabClick.emit(selectedTabs);
    }
}
